import { render, staticRenderFns } from "./goodspack.vue?vue&type=template&id=57b24c06&scoped=true"
import script from "./goodspack.vue?vue&type=script&lang=js"
export * from "./goodspack.vue?vue&type=script&lang=js"
import style0 from "./goodspack.vue?vue&type=style&index=0&id=57b24c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b24c06",
  null
  
)

export default component.exports